<div class="container-full bg-gradient">
    <div class="bg-skyline">
        <a href="https://www.lybox.fr">
            <img src="assets/logo-inline-alpha.png" class="logo"/>
        </a>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <mat-card id="loginForm">
                <mat-card-header>
                    <mat-card-title>Connexion à votre espace</mat-card-title>
                </mat-card-header>
                <mat-card-content>

                    <app-alert></app-alert>
                    <div *ngIf="forgotMsg == '1'" class="alert alert-success">
                        Mot de passe modifié, vous pouvez maintenant vous connecter.
                    </div>
                    <div *ngIf="forgotMsg == '2'" class="alert alert-success">
                        Un compte existe déja avec ce mail, veuillez vous connecter.
                    </div>

                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>E-mail</mat-label>
                            <input matInput formControlName="username" placeholder="E-mail" class="text">
                            <mat-error
                                *ngIf="loginForm.get('username').invalid">{{formService.getErrorMessage(loginForm.get('username'))}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group">
                        <mat-form-field class="pb-0">
                            <mat-label>Mot de passe</mat-label>
                            <input matInput formControlName="password" [type]="hide ? 'password' : 'text'" class="text">
                            <p mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                               [attr.aria-pressed]="hide">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </p>
                            <mat-error  *ngIf="loginForm.get('password').invalid">{{formService.getErrorMessage(loginForm.get('password'))}}</mat-error>
                        </mat-form-field>
                        <p class="lost-password">
                            <a [routerLink]="['/app/forgotPassword']">Mot de passe oublié</a>
                        </p>
                    </div>
                </mat-card-content>
                <mat-card-actions>
                    <button class="btn btn-primary" [disabled]="loginForm.invalid">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        Valider
                    </button>
                </mat-card-actions>

                <mat-card-content>
                    <hr/>
                    <div class="row">
                        <div class="col-md-6">
                            <a class="btn btn-facebook" (click)="signInWithFB()">
                                <i class="fa fa-facebook-official" aria-hidden="true"></i>
                                Se connecter
                            </a>
                        </div>
                        <div class="col-md-6">
                            <a class="btn btn-google" (click)="signInWithGoogle()">
                                <img src="/assets/Google_icon-icons.com_66793.png"/>
                                Se connecter
                            </a>
                        </div>
                    </div>
                    <hr/>
                    <a [routerLink]="['/app/register']" class="free-trial message alert-primary">
                        <i class="fa fa-clock-o"></i>
                        Inscrivez vous et profitez de <b>toutes les fonctionnalités</b> de LyBox gratuitement pendant <b>7 jours !</b>
                    </a>
                </mat-card-content>
            </mat-card>
        </form>
    </div>
    <div class="bg-sidelogin">
        <div id="picturesCarousel" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <h2>Parrainez vos amis !</h2>
                    <div class="col-6">
                        Pour votre filleul :<br/>
                        Un mois d’abonnement gratuit au choix
                    </div>
                    <div class="col-6">
                        Pour vous :<br/>
                        Autant de mois gratuits que de filleuls parrainés
                    </div>
                    <img src="assets/illustrations/parrainage.svg" />
                    <h3>Retrouvez votre code de parrainnage dans les paramètres de votre compte LyBox</h3>
                </div>
            </div>
        </div>
    </div>
</div>
